var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { RecordSubType } from './RecordSubType';
import { RecordState } from './RecordState';
import { HistoryEntryRow } from './HistoryEntryRow';
import { DecisionState } from './DecisionState';
var RecordHistoryTask = /** @class */ (function (_super) {
    __extends(RecordHistoryTask, _super);
    function RecordHistoryTask(task, i18n) {
        var _this = _super.call(this) || this;
        _this.i18n = i18n;
        Object.assign(_this, task);
        return _this;
    }
    Object.defineProperty(RecordHistoryTask.prototype, "displayTaskType", {
        get: function () {
            var subTaskString = "";
            if (this.taskType == "InvestmentReport") {
                subTaskString = "." + RecordSubType[this.taskSubType];
            }
            if (this.isFeedback) {
                var str = '';
                switch (this.taskType) {
                    case 'DeadlineChange':
                    case 'PurposeChange':
                    case 'TargetChange':
                        str = 'Feedback';
                        break;
                    case 'OrganisationYearlyReport':
                    case 'AidTargetYearlyReport':
                    case 'AccountNumberRequest':
                    case 'ExpandedStrategyAndBudgetaryEstimate':
                    case 'PaymentPlan':
                    case 'PaymentRequestExpenseReport':
                    case 'SummaryReport':
                    case 'RefundRequest':
                    case 'ClaimForRecovery':
                    case 'InvestmentReport':
                        str = 'HistoryFeedback';
                        break;
                    default:
                        str = '';
                        break;
                }
                return this.i18n.t("Forms." + this.taskType + subTaskString + str).toString();
            }
            return this.i18n.t("Forms." + this.taskType + subTaskString).toString();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecordHistoryTask.prototype, "displayState", {
        get: function () {
            var displayPath = null;
            if (this.isRefund) {
                displayPath = this.decisionState == DecisionState.Approved ? "RecordState.RefundReturned"
                    : this.decisionState == DecisionState.ClosedWithoutResult ? "RecordState.RefundClosedWithoutResult"
                        : "RecordState." + RecordState[this.state];
            }
            else if (this.isYearlyReport) {
                displayPath = this.decisionState == DecisionState.ClosedWithoutResult ? "RecordState.RefundClosedWithoutResult"
                    : "RecordState." + RecordState[this.state];
            }
            else {
                displayPath = this.isAidDecision
                    ? "RecordState.AidDecisionProcessed"
                    : "RecordState." + RecordState[this.state];
            }
            return this.i18n.t(displayPath).toString();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecordHistoryTask.prototype, "isRefund", {
        get: function () {
            return this.taskType == "RefundRequest" || this.taskType == "ClaimForRecovery";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecordHistoryTask.prototype, "isYearlyReport", {
        get: function () {
            return this.taskType == "OrganisationYearlyReport" || this.taskType == "AidTargetYearlyReport";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecordHistoryTask.prototype, "isAidProposal", {
        get: function () {
            return this.state === RecordState.ProposalRead;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecordHistoryTask.prototype, "isAidDecision", {
        get: function () {
            return this.taskType === "AidApplication" && this.state === RecordState.Processed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecordHistoryTask.prototype, "archiveButtonLabel", {
        get: function () {
            if (this.isAidProposal)
                return this.i18n.t("Btn_OrderAidProposal").toString();
            else if (this.isAidDecision)
                return this.i18n.t("Btn_OrderAidDecision").toString();
            else
                return this.i18n.t("Btn_OrderArhiveReport").toString();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecordHistoryTask.prototype, "tooltipContent", {
        get: function () {
            return this.i18n.t("RecordHistory.FeedbackOnlineView", [this.onlineViewDateString]).toString();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecordHistoryTask.prototype, "onlineViewDateString", {
        get: function () {
            var d = new Date(this.onlineViewAvailableUntil);
            return d.toLocaleDateString("fi");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RecordHistoryTask.prototype, "routeValue", {
        get: function () {
            var specification = this.isFeedback ? "Feedback" : "";
            switch (this.taskType) {
                case "OrganisationYearlyReport":
                    return "organisationYearlyReport" + specification;
                case "AidApplication":
                    if (this.isAidProposal)
                        return "aidProposal";
                    if (this.isAidDecision)
                        return "aidDecision";
                    return "aidApplication";
                case "AccountNumberRequest":
                    return "accountNumberRequest" + specification;
                case "AupReport":
                    return "aupReport";
                case "MaterialRequest":
                    return "materialRequest";
                case "ExpandedStrategyAndBudgetaryEstimate":
                    return "expandedsbe" + specification;
                case "PaymentPlan":
                    return "paymentPlan" + specification;
                case "PaymentRequestExpenseReport":
                    return "paymentRequestER" + specification;
                case "SummaryReport":
                    return "summaryReport" + specification;
                case "ContinuousReport":
                    return "continuousReport" + specification;
                case "RefundRequest":
                    return "refundRequest" + specification;
                case "ClaimForRecovery":
                    return "claimForRecovery" + specification;
                case "PaymentBan":
                    return "paymentBan";
                case "AidTargetYearlyReport":
                    return "aidTargetYearlyReport" + specification;
                case "GeneralNotification":
                    return "generalNotification";
                case "TransferredAmountNotification":
                    return "transferredAmountNotification";
                case "InspectionVisitNotification":
                    return "inspectionVisitNotification";
                case "DeadlineChange":
                    return "deadlineChange" + specification;
                case "PurposeChange":
                    return "purposeChange" + specification;
                case "TargetChange":
                    return "targetChange" + specification;
                case "InvestmentReport":
                    return this.taskSubType === RecordSubType.InvestmentBudgetaryEstimate
                        ? "investmentBudgetaryEstimateFeedback"
                        : "investmentFinalReportFeedback";
                case "LegacyInformationRequest":
                    return "legacyInformationRequest";
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    return RecordHistoryTask;
}(HistoryEntryRow));
export { RecordHistoryTask };
